<template>
    <v-tabs :value="value" centered show-arrows center-active class="tab tab--inline tab--underline-inline">
        <v-tab v-for="group in groups" :key="group.text" v-bind="group" exact-path>
            <span>{{ group.text }}</span>
        </v-tab>
    </v-tabs>
</template>

<script>
export default {
    props: ["value", "program"],
    computed: {
        hall() {
            return this.$route.params.hall;
        },
        groups() {
            return [{ text: "전체", to: `/auction-halls/${this.hall}/groups/all` }, ...(this.program?.groups || []).map((text) => ({ text, to: `/auction-halls/${this.hall}/groups/${text}` }))];
        },
    },
};
</script>

<style></style>
